import * as THREE from 'three';

/**
 * Lit surfaces skip a point light that is off or out of reach. The scene keeps fixed pools of point lights (spell orbs, nearby props), so
 * materials never recompile as lights come and go, and three lit every pixel by every one of them: in `goblin-battle` fourteen, nine of them
 * dark and the rest hundreds of metres away, about a third of the frame's GPU time at 1440p. A dark light (no colour, as three folds the
 * intensity into it) is the same for every pixel, so skipping it costs nothing; past a light's cutoff three's falloff is exactly zero, so
 * skipping there changes no pixel either. Applied once, before any program compiles.
 */
const chunk = THREE.ShaderChunk.lights_fragment_begin;
const start = 'pointLight = pointLights[ i ];';
if (!chunk.includes('pointLightReaches')) {
  // The point light loop's body runs from reading the light to its `RE_Direct` (built three drops the blank lines, so only these are matched).
  const at = chunk.indexOf(start), direct = chunk.indexOf('RE_Direct(', at), close = chunk.indexOf('\n', direct) + 1;
  if (at < 0 || direct < 0 || !close || !/^\s*}\s*#pragma unroll_loop_end/.test(chunk.slice(close))) {
    console.warn('Point light culling: three\'s lighting chunk changed; every point light lights every pixel.');
  } else {
    // An unrolled loop body may not declare a variable, so the test reads the light from its array each time.
    const reaches = '\n/* pointLightReaches */ if ( dot( pointLights[ i ].color, vec3( 1.0 ) ) > 0.0 && ( pointLights[ i ].distance <= 0.0'
      + ' || dot( pointLights[ i ].position - geometryPosition, pointLights[ i ].position - geometryPosition ) < pointLights[ i ].distance * pointLights[ i ].distance ) ) {';
    const after = at + start.length;
    THREE.ShaderChunk.lights_fragment_begin = chunk.slice(0, after) + reaches + chunk.slice(after, close) + '\t\t}\n' + chunk.slice(close);
  }
}
